import React from "react";
import ResizableTable from "./ResizableTable";
import type { DataTableProps } from "../types";

const DataTable: React.FC<DataTableProps> = ({
  data,
  headerData,
  hemisphere,
  currentMonth,
  scheduleFilter,
}) => {
  return (
    <ResizableTable
      data={data}
      columns={[]} // Will be ignored when isACNHTable is true
      isACNHTable={true}
      headerData={headerData}
      hemisphere={hemisphere}
      currentMonth={currentMonth}
      scheduleFilter={scheduleFilter}
      enableSorting={true}
      enableColumnResizing={true}
    />
  );
};

export default DataTable;
